import { render, staticRenderFns } from "./ExternalPlatformLink.vue?vue&type=template&id=79bcb8c3"
import script from "./ExternalPlatformLink.vue?vue&type=script&lang=js"
export * from "./ExternalPlatformLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports